import {DatosEnvioAfiliacion} from "../modelo/EnvioAfiliacion";

export const ENVIAR_SAT_AFILIADO = "ENVIAR_SAT_AFILIADO";
export const ENVIAR_SAT_MASIVO_AFILIADOS= "ENVIAR_SAT_MASIVO_AFILIADOS";
export const ERROR_AUTORIZACION = "ERROR_AUTORIZACION";
export const ERROR_ENVIO_AFILIACION_INDIVIDUAL = "ERROR_ENVIO_AFILIACION_INDIVIDUAL";
export const ERROR_ENVIO_AFILIACION_MASIVO = "ERROR_ENVIO_AFILIACION_MASIVO";
export const ENVIO_EXITOSO_AFILIACION = "ENVIO_EXITOSO_AFILIACION";
export const ENVIO_EXITOSO_AFILIACION_MASIVO = "ENVIO_EXITOSO_AFILIACION_MASIVO";
export const DESCARGAR_PLANTILLA_MASIVO_AFILIACION = "DESCARGAR_PLANTILLA_MASIVO_AFILIACION";
export const PLANTILLA_AFILIACION_OBTENIDA = "PLANTILLA_AFILIACION_OBTENIDA";
export const ERROR_OBTENIENDO_PLANTILLA_AFILIACION = "ERROR_OBTENIENDO_PLANTILLA";
export const LIMPIAR_MENSAJES_AFILIACION = "LIMPIAR_MENSAJES_AFILIACION";

export const enviarSATAfiliado = (datosEnvioAfiliacion: DatosEnvioAfiliacion) => ({ type: ENVIAR_SAT_AFILIADO, datosEnvioAfiliacion });
export const enviarSATMasivoAfiliados = (archivoEnvio: File) => ({ type: ENVIAR_SAT_MASIVO_AFILIADOS, archivoEnvio});
export const errorAutorizacion = () => ({ type: ERROR_AUTORIZACION});
export const errorEnvioAfiliacionIndividual = (mensajeRespuesta: string) => ({ type: ERROR_ENVIO_AFILIACION_INDIVIDUAL, mensajeRespuesta});
export const errorEnvioAfiliacionMasivo = (mensajeRespuesta: string) => ({ type: ERROR_ENVIO_AFILIACION_MASIVO, mensajeRespuesta});
export const envioAfiliacionExito = (poliza: string, dni: string) => ({ type: ENVIO_EXITOSO_AFILIACION, poliza, dni});
export const envioAfiliacionMasivoExito = () => ({ type: ENVIO_EXITOSO_AFILIACION_MASIVO});
export const descargarPlantillaMasivoAfiliacion = () => ({ type: DESCARGAR_PLANTILLA_MASIVO_AFILIACION});
export const plantillaAfiliacionObtenida = () => ({type: PLANTILLA_AFILIACION_OBTENIDA});
export const errorObteniendoPlantillaAfiliacion = () => ({type: ERROR_OBTENIENDO_PLANTILLA_AFILIACION});
export const limpiarMensajesAfiliacion = () => ({type: LIMPIAR_MENSAJES_AFILIACION});








// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_empresas/modulos/procesarEmpresaActions.ts